export default __webpack_public_path__ + "static/media/upSelected.b839125d.svg";